import Client from "./clients/rest";

export default {

    getZapCoupons(businessId, excel, object) {
        const query = new URLSearchParams(JSON.parse(JSON.stringify(object, (k, v) => v ?? undefined))).toString()
        return Client.get(`business/${businessId}/get_zap_coupons?excel=${excel}&${query ? query : ""}`);
    },

    updateCouponStatus(businessId, couponCode, couponStatus) {
        return Client.post(`business/${businessId}/update-coupon-status?couponCode=${couponCode}&couponStatus=${couponStatus}`);
    },

};
